import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
import { useData } from 'store/DataProvider';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: 0,
    },
    '& .MuiDialogActions-root': {
        padding: 0,
    },
}));

export default function CustomizedDialogs() {
    const [open, setOpen] = React.useState(false);
    const [value, setValue] = React.useState('');
    const [stations, setStations] = React.useState([]);
    const data = useData();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const resolveSelectedValue = React.useCallback((stationList, preferredValue) => {
        if (preferredValue && stationList.some((station) => station.id === preferredValue)) {
            return preferredValue;
        }
        return stationList[0]?.id || '';
    }, []);
    const selectedValue = resolveSelectedValue(stations, value || data.getStationId());
    const handleClickOpen = () => {
        const stationList = data.getStationList();
        const resolvedValue = resolveSelectedValue(stationList, value || data.getStationId());

        setStations(stationList);
        setValue(resolvedValue);
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue((event.target as HTMLInputElement).value);
    };
    
    const handleConfirm = () => {
        if (selectedValue && selectedValue !== data.getStationId()) {
            data.setStationId(selectedValue);
        }
        setOpen(false);
    };

    return (
        <React.Fragment>
            <Button
                variant="contained"
                size="small"
                sx={{
                    bgcolor: "#269FFF",
                    color: "#fff",
                    fontSize: 14,
                    fontWeight: 400,
                    borderRadius: "44px",
                    px: 2,
                    py: 0.5,
                    textTransform: "none",
                    boxShadow: "none",
                    "&:hover": {
                        bgcolor: "#269FFF",
                        boxShadow: 1,
                    },
                }}
                onClick={handleClickOpen}
            >
                切換旗站
            </Button>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
                fullWidth
                PaperProps={{
                    sx: {
                        display: "flex",
                        flexDirection: "column",
                        gap: 0,
                        p: 2.5,
                        borderRadius: 4,
                        maxWidth: !isMobile ? "500px" : "253px",
                    }
                }}
            >
                <DialogTitle
                    sx={{
                        m: 0,
                        p: 0,
                        mb: 1,
                        fontWeight: 500,
                        fontSize: "14px",
                        color: theme.palette.text.primary,
                    }}
                    id="customized-dialog-title"
                >
                    旗站選擇
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 12,
                        top: 12,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent sx={{ p: 0 }}>
                    <FormControl
                        fullWidth
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 0,
                            p: 0,
                            m: 0,
                            alignItems: "flex-start",
                        }}
                    >
                        <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            value={selectedValue}
                            onChange={handleChange}
                            name="radio-buttons-group"
                        >
                            {
                                stations.map((station) => (
                                    <FormControlLabel
                                        key={station.id}
                                        value={station.id}
                                        control={<Radio sx={{ p: 0, pr: 1 }} />}
                                        label={
                                                <span style={{
                                                    fontSize: "14px",
                                                    fontWeight: selectedValue === station.id ? 500 : 400,
                                                    lineHeight: "normal",
                                                    fontStyle: "normal",
                                                    color: selectedValue === station.id ? theme.palette.primary.main : 'inherit'
                                            }}>
                                                {station.stationName}
                                            </span>
                                        }
                                        sx={{
                                            mb: 1,
                                            ml: 0,
                                            mr: 0,
                                            '& .MuiRadio-root': {
                                                color: selectedValue === station.id ? theme.palette.primary.main : theme.palette.grey[400],
                                            }
                                        }}
                                    />
                                ))
                            }
                        </RadioGroup>
                    </FormControl>
                </DialogContent>
                <DialogActions sx={{ p: 0, mt: 1 }}>
                    <Button
                        autoFocus
                        onClick={handleConfirm}
                        fullWidth
                        disabled={!selectedValue}
                        sx={{
                            color: theme.palette.primary.contrastText,
                            bgcolor: theme.palette.primary.main,
                            fontSize: "14px",
                            fontWeight: 400,
                            borderRadius: "6px",
                            py: "6px",
                            textTransform: "none",
                            boxShadow: "none",
                            "&:hover": {
                                bgcolor: theme.palette.primary.main,
                                boxShadow: "6px",
                            },
                        }}
                    >
                        確認
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment>
    );
}
